import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  "aria-hidden": "true"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M5.328 11.283h13.333l-.025 1.459H5.303z" }, null, -1),
    _createElementVNode("path", { d: "M5.315 11.27H18.65l.025 1.459H5.34z" }, null, -1)
  ])))
}
export default { render: render }